var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('h1',{staticClass:"title"},[_vm._v("Vue Selfie")]),_vm._v(" "),_c('camera',{ref:"webcam"}),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{on:{"click":_vm.take_selfie}},[_vm._v("Take Selfie")])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d6e9040c","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 16
// module chunks = 0